import { TagERP, TagType } from "@finanedi.es/storybook"
import {
  faCircleCheck,
  faCircleXmark,
  faClock,
} from "@fortawesome/pro-light-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  ESTADO_INVITACION_ASESORIA,
  EstadoInvitacionAsesoriaType,
} from "api/Types/EstadoInvitacionAsesoria"
import { t } from "i18next"

export const EmpresaGestionadaEstado = (
  variant: EstadoInvitacionAsesoriaType,
  id?: string
) => {
  const ESTADO_INVITACION_ASESORIA_PROPERTIES: Record<
    EstadoInvitacionAsesoriaType,
    {
      icon: React.ReactNode
      color: TagType
      text: string
    }
  > = {
    [ESTADO_INVITACION_ASESORIA.ACEPTADA]: {
      icon: <FontAwesomeIcon icon={faCircleCheck} />,
      color: "success",
      text: t("empresasGestionadas.filterMenu.status.validated"),
    },
    [ESTADO_INVITACION_ASESORIA.PENDIENTE]: {
      icon: <FontAwesomeIcon icon={faClock} />,
      color: "alternativeOne",
      text: t("empresasGestionadas.filterMenu.status.unvalidated"),
    },
    [ESTADO_INVITACION_ASESORIA.RECHAZADA]: {
      icon: <FontAwesomeIcon icon={faCircleXmark} />,
      color: "danger",
      text: t("empresasGestionadas.filterMenu.status.rejected"),
    },
  }

  const { icon, color, text } =
    (variant && ESTADO_INVITACION_ASESORIA_PROPERTIES[variant]) || {}

  return (
    <div className='tw-flex tw-justify-center tw-items-center !tw-w-full'>
      <TagERP
        id={id}
        value={text}
        color={color}
        icon={icon}
      />
    </div>
  )
}
